jQuery(document).ready(function(jQuery) {

  /*################### Home Pages ######################*/
  
  /* Sticky Header */
  function sticky_section() {

    var header_h = jQuery('.site-header').height();

    jQuery(window).scroll(function(){
      var sticky = jQuery('.header-section'),
          scroll = jQuery(window).scrollTop();

      if (scroll >= 1){
        sticky.addClass('fixed');
        jQuery('body').addClass('fixed');
        jQuery('body').css('padding-top', header_h);
      }
      else {
        sticky.removeClass('fixed');
        jQuery('body').removeClass('fixed');
        jQuery('body').css('padding-top', '0');
      }
    });
  }
  sticky_section();
  jQuery(window).on('load resize orientationchange', sticky_section);

  /* Banner Caption Width */
  function banner_home_section() {
    var body_width = jQuery('body').width();
    
    var header_wrapper = jQuery('.main-header .wrapper').width();
    var temp_width = body_width - header_wrapper; 
    
    var temp_width_2 = temp_width / 2;  
    
    //jQuery(".banner-slilder .banner-wrapper .banner-item .banner-caption").css('left', temp_width_2);
    jQuery(".banner-inner-v2 .banner-caption").css('left', temp_width_2);
  }
  banner_home_section();
  jQuery(window).on('load resize orientationchange', banner_home_section);
  
  /* Image with map Section */
  function map_home_section() {
    var body_width = jQuery('body').width();
    var header_wrapper = jQuery('.main-header .wrapper').width();
    var temp_width = body_width - header_wrapper; 
    var temp_width_2 = temp_width / 2;  
    jQuery(".our-store-section .map-content").css('padding-right', temp_width_2);
    jQuery(".get-notified-section .notified-content").css('padding-right', temp_width_2);
    jQuery(".full-width-block .block-list .image-left .block-content").css('padding-right', temp_width_2);
    jQuery(".full-width-block .block-list .image-right .block-content").css('padding-left', temp_width_2);
    jQuery(".block-healthmail-service .right-table").css('padding-right', temp_width_2);
  }
  map_home_section();
  jQuery(window).on('load resize orientationchange', map_home_section);
  

  /* Slick Slider */
  jQuery('.js-banner-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          adaptiveHeight: true,
        }
      }
    ]
  });

  jQuery('.js-pro-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  jQuery('.js-logo-slider').slick({
    arrows: false,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });
  
  /*################### Product Page ################### */ 
  /*jQuery('.js-product-slider').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        
      }
    ]
  });*/
  
  jQuery('.js-product-slider1').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });
  
  //$(".p-accordion-content").hide(); 
  $(".p-accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.p-accordion-content').slideUp();
      $('.p-accordion-title').not(this).removeClass('active');
      $('.p-accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.p-accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.p-accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });
  
  /*################### Store Page ################### */ 
  $(".store-accordion-content").hide(); 
  $(".store-accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.store-accordion-content').slideUp();
      $('.store-accordion-title').not(this).removeClass('active');
      $('.store-accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.store-accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.store-accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });
  
  /*################### Cart Accordion ################### */ 
  $(".cart-accordion-content").hide(); 
  $(".cart-accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.cart-accordion-content').slideUp();
      $('.cart-accordion-title').not(this).removeClass('active');
      $('.cart-accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.cart-accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.cart-accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });

  /*################### Footer Accordion ################### */ 
  $(".f-accordion-content").hide(); 
  $(".f-accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.f-accordion-content').slideUp();
      $('.f-accordion-title').not(this).removeClass('active');
      $('.f-accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.f-accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.f-accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });
  
  /*################### FAQ Accordion ################### */ 
  $(".faq-accordion-content").hide(); 
  $(".faq-accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.faq-accordion-content').slideUp();
      $('.faq-accordion-title').not(this).removeClass('active');
      $('.faq-accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.faq-accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.faq-accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });

  /*################### Brand Filter ################### */ 
  var triggers = $('.brand-filter a');
  var filters = $('.brand-list .brand-item .brand-title');

  triggers.click(function() {
    $(".all-link").removeClass('active');
    var takeLetter = $(this).text(), result = 0;
    
    filters.parent().hide();
    
    triggers.removeClass('active');
    
    $(this).addClass('active');
    
    $('#result').show();
    
    filters.each(function(i) {
      if ( RegExp('^'+takeLetter).test($(this).text()) ) {
        result += 1;
        $(this).parent().fadeIn(222);
        
      } 
    });
    $('#result').html('<p>'+(result<1 ? 'Brands not avaliable.' : result+' Brands avaliable')+'</p>');
    //if (result<1) {alert('There is no result.');}
  });

  $(".brand-filter .all-link").click(function(){
    $(this).addClass('active');
    filters.parent().show();
    triggers.removeClass('active');
    $('#result').hide();
  });
  
  /* Scroll Button */
  jQuery(document).on('click', '.scroll-btn', function(event) {
    var jQueryanchor = jQuery(this);
    jQuery('html, body').stop().animate({
      scrollTop: jQuery(jQueryanchor.attr('href')).offset().top - 200
    }, 1500, 'easeInOutExpo');
    event.preventDefault();
  });
  
});